import { useState } from "react";
import {
  Anchor,
  Box,
  Divider,
  NavLink,
  Paper,
  ScrollArea,
  Text,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { adminData } from "./sidebarData";
import React from "react";

const SideBar = ({ setOpened }) => {
  const [active, setActive] = useState(0);
  const [subActive, setSubActive] = useState(0);

  const items = adminData.map((item, index) => (
    <Anchor variant="text" component={Link} to={item.path} key={index}>
      {item.hasDivider && <Divider m={10} />}
      {item.header && (
        <Text size="md" weight={500} color="dimmed" mx="sm">
          {item.header}
        </Text>
      )}
      <NavLink
        variant="filled"
        color={"red.9"}
        styles={{
          root: {
            color: "white",
            ":hover": {
              color: "white",
              backgroundColor: "#FF5952",
            },
          },
          label: { fontSize: "1rem" },
        }}
        // className={active === index ? "fgColorF" : ""}
        key={item.label}
        active={!item.subNav && active === index}
        label={index + 1 + " - " + item.label}
        description={item.description}
        // rightSection={item.rightSection}
        // icon={<item.icon className="fgColorF" size={25} stroke={1.5} />}

        onClick={() => {
          setActive(index);
          setSubActive(null);
          if (!item.subNav) {
            // setOpened(false);
          }
        }}
        // classNames={{
        //   body: {
        //     border: active === index ? "1px solid red" : "1px solid blue",
        //   },
        // }}
      >
        {item.subNav &&
          item.subNav.map((subItem, i) => (
            <Anchor
              variant="text"
              component={Link}
              to={subItem.path}
              key={subItem.label}
            >
              <NavLink
                variant="filled"
                color={"red.9"}
                styles={{
                  label: { fontSize: "1rem" },
                  root: {
                    color: "white",
                    ":hover": {
                      color: "white",
                      backgroundColor: "#FF5952",
                    },
                  },
                }}
                active={active === index && subActive === i}
                key={subItem.label}
                label={index + 1 + "." + (i + 1) + " - " + subItem.label}
                onClick={() => {
                  setSubActive(i);
                  setActive(index);
                  // setOpened(false);
                }}
              />
            </Anchor>
          ))}
      </NavLink>
    </Anchor>
  ));

  return (
    <Paper
      w={300}
      style={{ height: "100%", backgroundColor: "black" }}
      component={ScrollArea}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        {items}
      </Box>
    </Paper>
  );
};

export default SideBar;
